import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { FormattedMessage, injectIntl, defineMessages, FormattedNumber } from 'react-intl'
import Select, { Creatable } from 'react-select'
import Icon from "../icon/icon.component.jsx"
const uuidv4 = require('uuid/v4')

const messages = defineMessages({
    "quote.add_item_modal.configure.no_group_label": {
        id: 'quote.add_item_modal.configure.no_group_label',
        defaultMessage: 'Choose or create a group',
    },
})

class GroupSelect extends Component {

    constructor(props, context) {
        super(props, context);

        const options = this.props.groups ? this.props.groups.map(group => {
            return {
                value: group.id,
                label: group.attributes.name,
            }
        }) : []

        this.state = {
            groups: this.props.groups || [],
            options,
            selectedOption: this.props.selectedGroupId ? (options.find(op => op.value === this.props.selectedGroupId) || '') : '',
        }

        const defaultCallback = () => { }
        this.name = this.props.name
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            selectedOption: nextProps.selectedGroupId ? (this.state.options.find(op => op.value === nextProps.selectedGroupId) || '') : '',
        })
    }

    handleChange(selectedOption) {
        if (!selectedOption) {
            this.setState({
                selectedOption: '',
            }, () => {
                this.onChange('', '')
            })
            return
        }

        let isNewOption = this.state.options[0].value === this.state.options[0].label
        if (isNewOption) {
            selectedOption.value = uuidv4()
        }

        this.setState({
            selectedOption: selectedOption
        }, () => {
            this.onChange(selectedOption.value, isNewOption ? this.state.options[0].label : selectedOption.label)
        });
    }

    render() {
        return <div><Creatable
            name={this.name}
            multi={false}
            value={this.state.selectedOption}
            onChange={this.handleChange}
            options={this.state.options}
            promptTextCreator={userInput =>
                <span className="text-primary">
                    <Icon value={"layer-group"} className={"mr-1"} /> <small><FormattedMessage
                        id="quote.add_item_modal.configure.create_group_label"
                        defaultMessage="Create group {groupName}"
                        values={{
                            groupName: userInput,
                        }}
                    />
                    </small>
                </span>
            }
            placeholder={this.props.intl.formatMessage(messages['quote.add_item_modal.configure.no_group_label'])}
            style={{ fontSize: 14 }}
        />
        </div>
    }
}

export default injectIntl(GroupSelect)





// WEBPACK FOOTER //
// ./src/common/pricing/groupselection.component.jsx